import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TranslateModule } from "@ngx-translate/core";
import { BackButtonComponent } from "src/app/shared/component/back-button/back-button.component";
import { SharedModule } from "src/app/shared/shared.module";
import { ValidatesCertificateComponent } from "./validates-certificate.component";
import { ValidatesCertificateRoutingModule } from "./validates-certificate.routing";

@NgModule({
    declarations: [ValidatesCertificateComponent],
    imports: [
        CommonModule,
        ValidatesCertificateRoutingModule,
        FlexModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        TranslateModule,
        MatToolbarModule,
        SharedModule,
        MatCardModule,
        FormsModule,
        BackButtonComponent
    ]
})
export class ValidatesCertificateModule {}
